module.exports = {"513333100":"色柯镇","513333101":"翁达镇","513333102":"洛若镇","513333103":"泥朵镇","513333201":"克戈乡","513333202":"然充乡","513333203":"康勒乡","513333204":"大章乡","513333205":"大则乡","513333206":"亚龙乡","513333207":"塔子乡","513333208":"年龙乡","513333210":"霍西乡","513333211":"旭日乡","513333212":"杨各乡","513333213":"甲学乡","513333214":"歌乐沱乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513333.json
// module id = 2238
// module chunks = 0